<template>
  <div id="choose-plan">
    <!-- 有plan 或者从manage subs进入时显示 -->
    <div
      class="header"
      v-if="!showPlanDetail && (chooseFrom === 'manageSubs' || this.existPlan)">
      <div
        class="title"
        @click="goBack">
        <span class="el-icon-arrow-left"></span><span>Choose a plan</span>
      </div>
    </div>

    <div v-if="showPlanDetail">
      <plan-detail
        :plan="planDetail"
        @reselect="reselect"
        :existPlan="existPlan"></plan-detail>
    </div>
    <div
      class="plan-list"
      v-else>
      <plan-card
        :plan="item"
        v-for="item in planList"
        :key="item.id"
        @planchoose="planchoose"
        :existPlan="allSubscriptions.find(i => i.planId === item.id)"></plan-card>
    </div>
    <!-- <transition name="fade" mode="in"  appear>
      <plan-detail v-if="showPlanDetail" :plan="planDetail" @reselect="reselect"></plan-detail>
    </transition> -->
  </div>
</template>

<script>
import PlanCard from './PlanCard.vue'
import PlanDetail from './PlanDetail.vue'
// import { mapState } from "vuex";
import { GET_NAMES } from '@/queries'
import { handleNewSub, queryPrice } from '@/common/checkuser.js'
import { Message } from 'element-ui'
import { mapState } from 'vuex'
const orderMap = {
  on_demand: 1,
  one_year_unlimited: 2,
  three_year_unlimited: 3
}
export default {
  components: {
    PlanCard,
    PlanDetail
  },
  props: {
    existPlan: Object || null,
    from: String,
    nodeType: String,
    chooseFrom: String,
    allSubscriptions: Array
  },
  inject: ['emailid', 'loadData', 'PlansInfo'],
  data () {
    return {
      planList: [],
      planDetail: null,
      showPlanDetail: false,
      showConvertDialog: false,
      currentPlanInfo: {},
      convertPlanInfo: {}
    }
  },
  apollo: {
    plans: {
      query: GET_NAMES,
      fetchPolicy: 'network-only',
      notifyOnNetworkStatusChange: true,
      credentials: true,
      variables () {
        return {
          customerId: this.emailid,
          product: this.product,
          classification: 3
        }
      },
      result ({ data, loading, error }) {
        if (data) {
          const planList = data.plan.plans || []
          // const nodeType = this.nodeType == 'cloud' ? 1 : 2
          const nodeType = 3
          console.log(this.existPlan)
          const plans = planList.filter(i => {
            if (i.id.includes('_ppu') && this.existPlan && this.existPlan.planId) {
              console.log('ppu')
              return false
            }
            return i.classification == nodeType
          }).map(i => Object.assign(i, this.createPlan(i.id)))
          plans.sort((a, b) => {
            const orderA = orderMap[a.id] || Infinity
            const orderB = orderMap[b.id] || Infinity
            return orderA - orderB
          })
          this.planList = plans
        }
        this.plansLoading = loading
        this.error = error
      }
    }
  },
  methods: {
    handleClickConvert () {
      this.handleCheckOut(this.convertPlanInfo.chargeItem)
    },
    // 点击 buy
    handleCheckOut (chargeItem) {
      this.checkOutLoading = true
      // const planchargeItems = this.plan.chargeItems
      // const { InputNumber, TimeCredit } = this.handleAddOn(planchargeItems)
      // const quantity = Number(this.inputAddHours)
      // const chargeItems = {
      //   [InputNumber.addonId]: InputNumber.quantity,
      //   [TimeCredit.addonId]: quantity
      // }
      const params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.existPlan.planId,
        chargeItems: JSON.stringify(chargeItem),
        description: `${this.existPlan.planName} ${this.emailid} checkoutSubscription`
      }
      handleNewSub(params, this).then((res) => {
        console.log(res)
        this.paySuccess = true
        this.checkOutLoading = false
        this.loadData()
      }).catch(err => {
        this.checkOutLoading = false
        if (err.type != 'NO-CARD') {
          Message.error({
            message: err.info,
            duration: 5000
          })
        }
        if (err.type == 'REDIRECT') {
          // 跳到第三方页面， 添加监听页面切回来
          this.handlePayRedirect()
        }
      })
    },
    handlePayRedirect () {
      // 只需要监听一次
      const _this = this
      function visibilitychange () {
        if (!window.document.hidden) {
          console.log('visibilitychange')
          _this.loadData()
        }
      }
      window.document.addEventListener('visibilitychange', visibilitychange, { once: true })
    },
    handleAddOn (chargeItems) {
      let InputNumber = {}
      let TimeCredit = {}
      let Output = {}
      chargeItems.forEach(i => {
        if (i.addonId == 'producer-input-number') {
          InputNumber = i
        } else if (i.addonId == 'producer-time-credit') {
          TimeCredit = i
        } else if (i.addonId == 'producer-additional-output') {
          Output = i
        }
      })

      return { InputNumber, TimeCredit, Output }
    },
    // 选择一个PLAN
    // 如何是PPU就直接支付
    planchoose (params) {
      const { id } = params
      const item = this.planList.find(i => i.id == id)
      this.planDetail = {
        ...item
      }
      this.showPlanDetail = true
      this.$emit('titlechange', '')
    },
    getPlanList () {
      // const params = {

      // }
    },
    createPlan (id) {
      return this.PlansInfo[id]
    },
    // choose plan 操作完成后
    planchooseDone (id) {
      console.log(id)
      const item = this.planList.find(i => i.id == id)
      console.log(item)
      if (!item) return
      if (this.from == 'dashboard') {
        this.$emit('choose', item)
      } else {
        // 到plan detail页面
        this.showPlanDetail = true
        this.$emit('titlechange', '')
        this.planDetail = item
      }
    },
    // 返回上一级
    reselect () {
      this.showPlanDetail = false
      this.planDetail = null
      if (this.existPlan || this.chooseFrom === 'manageSubs') {
        this.$emit('titlechange', '')
      } else {
        // this.$emit('titlechange', 'Choose a plan')
        this.$emit('titlechange', 'plan')
      }
    },
    goBack () {
      this.$emit('reselectPlan', this.chooseFrom)
    },
    // 处理quantity s
    handleQuantity (value) {
      if (!value || value == 0 || isNaN(value)) {
        return '0h 00min'
      } else {
        let abs = ''
        if (value < 0) {
          abs = '-'
          value = Math.abs(value)
        }
        value = value / 60
        const hour = Math.floor(value / 60)
        let min = Math.ceil(value % 60)
        min = min < 10 ? '0' + min : min
        return `${abs} ${hour}h ${min}min`
      }
    },
    // 查询价格
    handleQueryPrice (chargeItems, type) {
      const params = {
        customerId: this.emailid,
        product: 'Producer',
        planId: this.existPlan.planId,
        chargeItems: JSON.stringify(chargeItems)
      }

      queryPrice(params).then(({ data }) => {
        if (data.previewCustomSubscription) {
          if (type == 'current') {
            this.currentPlanInfo.quantity = Number(data.previewCustomSubscription.quantity)
          } else {
            this.convertPlanInfo.quantity = Number(data.previewCustomSubscription.quantity)
          }
          this.$forceUpdate()
        }
      })
    }
  },
  computed: {
    ...mapState({
      product: 'product'
    })
  }
}
</script>

<style lang="less" scoped>
#choose-plan {
  // width: 600px;
  position: relative;
  .plan-list {
    display: flex;
  }
  .header {
      position: absolute;
      width: 50%;
      top: -60px;

      .title {
        line-height: 24px;
        font-weight: 700;
        font-size: 18px;
        // color: #303133;
        cursor: pointer;
      }
      .el-icon-arrow-left {
        font-weight: 900;
      }
  }
  .convert-dialog {
    display: flex;
    align-items: center;
    text-align: left;
    justify-content: space-between;
    // padding-top: 20px;
    .title {
      color: var(--dialog-input-color);
      font-size: 24px;
      margin: 40px 0;
    }
    .el-icon-right {
      font-size: 24px;
      color: var(--dialog-input-color);
      margin-top: 40px;
    }
    .charge-wrap {
      margin: 5px 0;
      color: var(--dialog-text-info-color);
      .value {
        color: var(--dialog-input-color);
      }
      .convert-value {
        color: #33AB4F;
      }
      p {
        margin: 5px 0;
      }
    }
  }
  .plan-footer {
    height: 60px;
    margin-top: 50px;
    .choose {
      border: 1px solid #33AB4F;
      color: var(--dialog-input-color);
      width: fit-content;
      max-width: 200px;
      height: 16px;
      line-height: 16px;
      padding: 10px 8px;
      text-align: center;
      border-radius: 5px;
      margin: 0 auto;
      cursor: pointer;
      transition: all .3s;
      user-select: none;
      background: #33AB4F;
    }
  }
}
</style>
